import styled from 'styled-components';
import Parent from '../Base/style';
const Wrapper = styled(Parent)`
    ${({theme})=>`
    color: ${theme.colors.FORM_COLOR} !important;
    font-size: 14px !important;
`}`;

export default Wrapper;
